import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import '@cigna/leaf-web/lib/wc/components/select-tile-list/select-tile-list';
import type { LeafSelectTileList } from '@cigna/leaf-web/lib/wc';

@Component({
  selector: 'cigna-leaf-select-tile-list',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-select-tile-list
      [ariaLabel]="ariaLabel"
      [flexDirection]="flexDirection"
      [label]="label"
      [fieldNote]="fieldNote"
      [ariaDescribedBy]="ariaDescribedBy"
      [fieldNoteKnockout]="fieldNoteKnockout"
      [fieldNoteIsSuccess]="fieldNoteIsSuccess"
      [fieldNoteIsError]="fieldNoteIsError"
    >
      <ng-content></ng-content>
    </leaf-select-tile-list>
  `,
})
export class CignaLeafSelectTileListComponent {
  @Input() ariaLabel: LeafSelectTileList['ariaLabel'];
  @Input() flexDirection: LeafSelectTileList['flexDirection'];
  @Input() label: LeafSelectTileList['label'];
  @Input() fieldNote: LeafSelectTileList['fieldNote'];
  @Input() ariaDescribedBy: LeafSelectTileList['ariaDescribedBy'];
  @Input() fieldNoteKnockout: LeafSelectTileList['fieldNoteKnockout'];
  @Input() fieldNoteIsSuccess: LeafSelectTileList['fieldNoteIsSuccess'];
  @Input() fieldNoteIsError: LeafSelectTileList['fieldNoteIsError'];
}
